import { api } from "services/api.service";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";

export async function action({ params }: { params: Record<string, string | undefined> }) {
  const res = await withActionErrorAlert(async () => {
    await api.request({
      method: "DELETE",
      url: `/location_management/location_type_movement_conditions/${params.locationTypeMovementConditionId}`,
    });
  });
  if (res?.status === 200) {
    return redirect("/location-type-movement-conditions");
  }
  return res;
}
